import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const CalendarExclamationIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/calendar-exclamation"><path id="Icon" d="M6.75 2V4.25M17.25 2V4.25M3 17.75V6.5C3 5.25736 4.00736 4.25 5.25 4.25H18.75C19.9926 4.25 21 5.25736 21 6.5V17.75M3 17.75C3 18.9926 4.00736 20 5.25 20H18.75C19.9926 20 21 18.9926 21 17.75M3 17.75V10.25M21 17.75V10.25M11.9998 8.5V12.25M11.9998 15.25H12.0073V15.2575H11.9998V15.25Z" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default CalendarExclamationIcon;